export default "__VITE_ASSET__DgqwofPn__"